import { en, tr, type MessageKey } from "./messages";
import type { ResolvedUiLanguage } from "./locale";

const catalogs: Record<ResolvedUiLanguage, Record<MessageKey, string>> = { en, tr };

export type MessageVars = Record<string, string | number>;
export type Translator = (key: MessageKey, vars?: MessageVars) => string;

export function translate(
  language: ResolvedUiLanguage,
  key: MessageKey,
  vars?: MessageVars,
): string {
  return interpolate(catalogs[language][key] ?? catalogs.en[key] ?? key, vars);
}

export function interpolate(template: string, vars?: MessageVars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.hasOwn(vars, name) ? String(vars[name]) : match,
  );
}
